module.exports = __webpack_public_path__ + "static/media/iconWrite3.24b2d2ca.svg";